<!-- BEGIN error -->
<div class="error">
    <div class="error-code">SERVER DOWN</div>
    <div class="error-content">
        <div class="error-message">The server is currently down for maintenance. Please try again later.</div>
        <div class="error-desc mb-4">
            We apologize for the inconvenience. The page you're looking for might not be available at the moment. <br />
            You may want to visit other pages to find what you're looking for.
        </div>
        <div>
            <a href="/account/login" class="btn btn-success px-3">Back to Login</a>
        </div>
    </div>
</div>

<!-- END error -->